module.exports = __webpack_public_path__ + "img/left.f06a9242.png";